import {
  Flex,
  Icon,
  Text,
  TooltipWrapper,
  CopyToClipboardButton,
} from "dash-ui";
import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";

export const AppIdSection = ({ appId }: { appId: string | null }) => {
  const theme = useTheme();
  const { t } = useTranslation(["pages"]);

  return (
    <Flex mt={4} flexDirection="column">
      <Flex alignItems="center">
        <Text semibold>{t("pages:profilePage:api:apiKeys")}</Text>
        <TooltipWrapper
          content={t("pages:profilePage:api:tooltipMessage")}
          mt={-1.5}
          ml={-2}
        >
          <Flex mt={0} ml={3} alignItems="center">
            <Icon name="infoCircle" color="#94a3b8" />
          </Flex>
        </TooltipWrapper>
      </Flex>
      <Flex mt={0.5} alignItems="center">
        <Text color={theme.colors.n70}>
          Your <strong>App ID</strong> is: {appId ?? "searching App ID"}
        </Text>
        <CopyToClipboardButton
          successMessage="App ID copied!"
          textToCopy={appId || ""}
        />
      </Flex>
    </Flex>
  );
};
